import { render, staticRenderFns } from "./form-switch.component.vue?vue&type=template&id=af6a3aec&scoped=true"
import script from "./form-switch.component.vue?vue&type=script&lang=js"
export * from "./form-switch.component.vue?vue&type=script&lang=js"
import style0 from "./form-switch.component.vue?vue&type=style&index=0&id=af6a3aec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af6a3aec",
  null
  
)

export default component.exports